import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Input, Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from 'reactstrap';

import api from '../../api/api';
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

class TableArchivos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            archivos: props.archivos,
            selectedRow: null
        }
    }

    componentDidUpdate(prevProps) {
        const { archivos } = this.props;
        if (prevProps.archivos !== archivos) {
            this.setState({ archivos });
        }
    }

    onChange = data => {
            this.setState(
                prevState => ({
                archivos: prevState.archivos.concat(data)
            }),
            () => this.props.onChange(this.state.archivos)
        );
    }

    onDelete = row => {
        this.setState(
            prevState => {
                prevState.archivos.splice(row, 1);
                return {
                    archivos: prevState.archivos,
                    selectedRow: null
                }
            },
            () => this.props.onChange(this.state.archivos)
        );
    }

    render() {
        const { archivos, selectedRow } = this.state;
        const { action } = this.props;
        return (
            <div className="ui-contact-table ui-file-table">
                { (action === 'CREATE' || action === 'EDIT') ?
                    <Fragment>
                        <ModalArchivos
                            onChange={this.onChange}
                            action="create"
                        />
                        <ModalArchivos
                            onDelete={this.onDelete}
                            value={archivos[selectedRow]}
                            row={selectedRow}
                            action="delete"
                        />
                    </Fragment> :
                    <ModalArchivos
                        value={archivos[selectedRow]}
                        row={selectedRow}
                        action="download"
                        url={this.props.url}
                    />
                }
                <Table size="sm" className="ui-contact-table-grid ui-file-table-grid">
                    <thead>
                        <tr>
                            <th>Archivos</th>
                        </tr>
                    </thead>
                    <tbody>
                        { archivos.map(
                            (archivo, i) =>
                                <tr
                                    key={i}
                                    onClick={() => this.setState(prevState => ({
                                        selectedRow: prevState.selectedRow === i ? null : i
                                    }))}
                                    className={selectedRow === i ? 'is-selected' : ''}
                                >
                                    <td>{(archivo.archivo && archivo.archivo.name) || archivo.nombre}</td>
                                </tr>
                            )
                        }
                        { archivos.length === 0 &&
                            <tr>
                                <td className="text-center ui-contact-table-empty" colSpan={1}>No hay archivos</td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>
        );
    }
}

class ModalArchivos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            archivo: null,
            archivoURL: '',
            isOpen: false
        }
    }

    static propTypes = {
        action: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        onDelete: PropTypes.func,
        disabled: PropTypes.bool
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                archivo: nextProps.value.archivo
            });
        }
    }

    actionData = {
        delete: {
            icon: 'fa fa-minus',
            color: 'danger',
            title: 'Eliminar archivo',
            button: 'Eliminar',
            buttonColor: 'danger',
            disabled: true,
            buttonFn: this.deleteFile
        },
        create: {
            icon: 'fa fa-plus',
            color: 'secondary',
            title: 'Agregar archivo',
            button: 'Agregar',
            buttonColor: 'success',
            disabled: false,
            buttonFn: this.toggle
        },
        download: {
            icon: 'fa fa-download',
            color: 'secondary',
            title: 'Descargar archivo',
            button: false,
            disabled: true,
            buttonFn: this.downloadFile
        }
    };

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    close = () => {
        this.setState({
            archivo: '',
            descripcion: '',
        });
        this.toggle();
    }

    onChangeField = (field, value) => {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    onSubmit = () => {
        const { action, row } = this.props;
        if (action === 'create') {
            const { archivo } = this.state;
            if (archivo) {
                this.props.onChange({ archivo });
                this.close();
            }
        } else if (action === 'delete') {
            this.props.onDelete(row);
            this.close();
        }
    }

    downloadFile = () => {
        const { url, value } = this.props;
        if (value && url) {
            window.open(url.replace('$id_archivo', value.id) + '?hash=' + value.hash);
        }
    }

    deleteFile = () => {
        this.toggle();
    }

    render() {
        const { isOpen } = this.state;
        const { action, disabled, row } = this.props;
        const actionData = this.actionData[action];
        return (
            <Fragment>
                { !disabled &&
                    <Button
                        color={actionData['color']}
                        onClick={action === 'create' ? this.toggle : (action === 'delete') ? this.deleteFile : this.downloadFile }
                        size="sm"
                        className="mr-1 btn-table-modal rounded"
                        disabled={(action === 'download' || action === 'delete') && (row === null)}
                    >
                        <i className={actionData['icon']} aria-hidden="true"></i>
                    </Button>
                }
                <Modal isOpen={isOpen} toggle={this.toggle} className={"ui-paradigma-modal" + (action === 'delete' ? " modal-danger" : "")}>
                    <ModalHeader toggle={this.toggle}>
                        { actionData['title'] }
                    </ModalHeader>
                    <ModalBody>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">
                                { action === 'delete' ? 'Confirmación' : 'Archivo' }
                            </p>
                            {
                                action === 'delete' ?
                                <p className="ui-inline-message">¿Está seguro que desea eliminar este archivo?</p> :

                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    inputComponent={
                                        <Input
                                            className="ui-file-input"
                                            onChange={e => this.setState({ archivo: e.target.files[0] })}
                                            type="file"
                                            disabled={actionData['disabled']}
                                        />
                                    }
                                />
                            }
                        </section>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Cancelar</Button>
                        { actionData['button'] &&
                            <Button color={actionData['buttonColor']} onClick={this.onSubmit}>
                                {actionData['button']}
                            </Button>
                        }
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

export default TableArchivos;



// WEBPACK FOOTER //
// ./src/views/Loteos/TableArchivos.js